import { SelectModule, SelectChangeEvent, SelectFilterEvent } from 'primeng/select';

import { FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';
import {
  input,
  output,
  OnInit,
  computed,
  Component,
  TemplateRef,
  contentChild,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SelectSize } from './types';

import { SvgIcon } from '../../ui/svg-icon';

@Component({
  selector: 'app-select',
  imports: [SelectModule, NgTemplateOutlet, SvgIcon, FormsModule],
  templateUrl: './select.html',
  styleUrl: './select.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'selectClasses()',
  },
})
export class Select implements OnInit {
  public selectedValueInput = input<any>();

  selectedValue: any;

  public options = input<any[] | undefined>();

  public optionLabel = input<string | undefined>();

  public optionValue = input<string | undefined>();

  public placeholder = input<string | undefined>();

  public filterPlaceholder = input<string>('Type to search...');

  public filter = input<boolean>(false);

  public showClear = input<boolean>(false);

  public loading = input<boolean>(false);

  public size = input<SelectSize>('default');

  public optionSelectedEvent = output<SelectChangeEvent>();

  public filterEvent = output<SelectFilterEvent>();

  public selectClasses = computed(() => ` ${this.size()} `);

  protected readonly footerTemplate = contentChild('footer', { read: TemplateRef });

  ngOnInit(): void {
    this.selectedValue = this.selectedValueInput();
  }

  protected onOptionSelect(event: SelectChangeEvent) {
    this.optionSelectedEvent.emit(event);
  }

  protected onFilter(event: SelectFilterEvent) {
    this.filterEvent.emit(event);
  }
}
